export default "__VITE_ASSET__BKMCmr70__"